import type { TOC } from '@ember/component/template-only';
import SettingsCostCreateProfile from 'lumen/components/settings/cost/create-profile';
import type MarketSettingsCostNewController from 'lumen/controllers/market/settings/cost/new';

interface MarketSettingsCostNewSignature {
  Args: {
    controller: MarketSettingsCostNewController;
  };
}

const MarketSettingsCostNew: TOC<MarketSettingsCostNewSignature> = <template>
  <SettingsCostCreateProfile
    @bookingWindows={{@controller.bookingWindowRows}}
    @commissionValue={{@controller.commissionValue}}
    @costError={{@controller.costError}}
    @description={{@controller.description}}
    @isSaveDisabled={{@controller.isSaveDisabled}}
    @isSaving={{@controller.saveTask.isRunning}}
    @mode={{@controller.mode}}
    @name={{@controller.name}}
    @nameError={{@controller.nameError}}
    @onAdvancedCellChange={{@controller.updateAdvancedCell}}
    @onCommissionValueChange={{@controller.updateCommissionValue}}
    @onDescriptionInput={{@controller.updateDescription}}
    @onModeChange={{@controller.updateMode}}
    @onNameInput={{@controller.updateName}}
    @onSave={{@controller.saveTask.perform}}
    @onUnitChange={{@controller.updateUnit}}
    @unit={{@controller.unit}}
  />
</template>;

export default MarketSettingsCostNew;
